<template>
    <div>
        <el-breadcrumb separator="/">
            <el-breadcrumb-item>
                <span class="page-title"><span style="font-weight: bolder;">用户标签信息</span></span></el-breadcrumb-item>
        </el-breadcrumb>
        <div style="padding-bottom: 30px;"></div>
        <el-form :inline="true" label-width="150px;">
            <el-form-item label="用户ID">
                <el-input v-model="userId" placeholder="请输入用户ID" clearable></el-input>
            </el-form-item>
            <el-form-item label="账号">
                <el-input v-model="account" placeholder="请输入手机或邮箱号码" clearable></el-input>
            </el-form-item>
            <el-form-item label="邀请码">
                <el-input v-model="inviteCode" placeholder="请输入邀请码" clearable></el-input>
            </el-form-item>
            <el-form-item label="实名ID">
                <el-input v-model="idNo" placeholder="请输入实名ID" clearable></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="submitQuery">查询</el-button>
            </el-form-item>
            <el-form-item>
                <el-button type="success" @click="downBtn()">下载</el-button>
            </el-form-item>
        </el-form>

        <el-table :data="userTags">
            <el-table-column prop="id" v-if="false"></el-table-column>
            <el-table-column label="用户ID" prop="userId"></el-table-column>
            <el-table-column label="手机账户" prop="tel"></el-table-column>
            <el-table-column label="邮箱账户" prop="email"></el-table-column>
            <el-table-column label="邀请码" prop="inviteCode"></el-table-column>
            <el-table-column label="实名ID" prop="idNo"></el-table-column>
            <el-table-column label="标签" prop="tagName"></el-table-column>
            <el-table-column label="标签描述" prop="tagDesc"></el-table-column>
            <el-table-column label="开关" width="70">
                <template slot-scope="scope">
                    <el-switch v-model="scope.row.tagStatus" active-color="#13ce66" inactive-color="#ff4949" @change="alterTagStatus(scope.row.id,scope.row.tagStatus)"></el-switch>
                </template>
            </el-table-column>
            <el-table-column label="历史标签描述" width="150">
                <template slot-scope="scope">
                     <el-popover
                    placement="bottom"
                    trigger="hover"
                   >
                   <div style="word-break:break-all;">{{scope.row.hisTagDesc}}</div>
                        <!-- <el-button slot="reference">{{scope.row.hisTagDesc}}</el-button> -->
                         <el-button slot="reference">查看历史标签</el-button>
                    </el-popover>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination background layout="prev, pager, next" :total="tagTotal" :page-size="10" :current-page="pageNo" @current-change="changePage"></el-pagination>
        <div style="font-weight: bolder;padding-bottom: 30px;padding-top: 30px;">用户标签新增或修改</div>
        <el-form label-width="150px">
            <el-form-item label="操作的用户ID">
                <el-input v-model="insertUserId" style="width: 300px;"></el-input>
            </el-form-item>
            <el-form-item label="特别关注：">
                <el-form>
                    <el-form-item label="标签描述"><el-input type="textarea" v-model="volunteer.desc" autosize style="width: 500px;margin-bottom: 20px;"></el-input></el-form-item>
                    <el-form-item><el-button type="success" @click="submitInsert(volunteer.tag)">确认提交</el-button></el-form-item>
                </el-form>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
    import api from './api';
    import {mapState, mapActions} from 'vuex';
    import './store';


    export default {
        name: "userTag",
        data() {
            return {
                userId: '',
                account:'',
                inviteCode:'',
                idNo:'',
                pageNo: 1,
                insertUserId : '',
                volunteer: {tag : 'SPECIAL_FOCUS',desc:''},
                projectDesc: {pair : '',level : '',machine : []},
                sta:true,
                userTags:[],
                tagTotal:0,
            }
        },
        computed: {
            ...mapState('userTags', [ 'machineType','userIds'])
        },
        created() {
          // this.findMachineType();
          this.submitQuery();
        },
        methods: {
            ...mapActions('userTags', ['findUserTags','findMachineType']),
            changePage(pageNo) {
                this.pageNo = pageNo;
                this.submitQuery();
            },
            com(){
                return 1
            },
            submitQuery() {
                let page = {page:1,size:10}
                if(this.userId || this.account || this.inviteCode || this.idNo){
                    page = {page:1,size:10}
                }else{
                    page = {page:this.pageNo,size:10}
                }
                let data = {userId: this.userId,account:this.account,inviteCode:this.inviteCode,idNo:this.idNo, ...page};
                // this.findUserTags(data);
                api.getUserTags(data).then(response => {
                    this.userTags = response.data.list;
                    this.tagTotal = response.data.totalCount;
                    if(this.userId || this.account || this.inviteCode || this.idNo){
                        if(response.data.list)
                        this.insertUserId = response.data.list[0].userId
                    }else{
                        this.insertUserId = ''
                    }

                })

            },

            submitInsert(type) {
                let desc;
                 switch (type) {
                     case 'SPECIAL_FOCUS' : desc = this.volunteer.desc;break;
                     case 'PROJECT_HOLDER': desc = JSON.stringify(this.projectDesc);break;
                 }

                 let data = {
                     userId: this.insertUserId,
                     tag : type,
                     desc: desc
                 }
                api.insertUserTags(data).then(() => {
                    this.$message.success("新增成功");
                    this.pageNo = 1;
                    this.submitQuery();
                })
            },
            alterTagStatus(tagId,tagStatus) {
                api.alterUserTagStatus({tagId: tagId,tagStatus: tagStatus});
            },
            downBtn() {
                api.excelUserTag().then(response =>{
                    const fileName = "用户标签信息.xlsx";
                    const blob = new Blob([response], {type: 'application/vnd.ms-excel'});
                    if ('download' in document.createElement('a')) {
                        const link = document.createElement('a');
                        link.download = fileName;
                        link.style.display = 'none';
                        link.href = URL.createObjectURL(blob);
                        document.body.appendChild(link);
                        link.click();
                        URL.revokeObjectURL(link.href);
                    } else {
                        navigator.msSaveBlob(blob, fileName);
                    }
                })
            }
        }
    }
</script>

<style scoped>

</style>
